import { UserTypeEnum } from 'src/services/GraphQL';
import type { IProfileDadataFIO } from './IProfileDadataFIO';
import { USER_TAGS } from './IUserProfile';

export interface IUserProfileEditFrontend {
  id?: string | null;
  fioData?: IUserProfileEditFrontend.IFioObject | null;
  birthday?: string | null;
  userType?: IUserProfileEditFrontend.IUserType | null;
  gender?: string | null;
  tenant?: IUserProfileEditFrontend.ITenant | null;
  isBlocked?: boolean | null;
  blockingReasonDescription?: string | null;
  blockedAt?: string | null;
  createdAt?: string | null;
  tags: IUserProfileEditFrontend.IUserTag[] | null;
}

export namespace IUserProfileEditFrontend {
  export interface IFioObject {
    dadataFio?: IProfileDadataFIO | null;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
  }

  export interface ITenant {
    name?: string | null;
    id?: string | null;
  }

  export interface IUserType {
    label?: string | null;
    name?: UserTypeEnum | null;
  }

  export interface IUserTag {
    key: USER_TAGS;
    value: USER_TAGS;
  }
}
